export enum RequestStatus {
  Draft = "Draft",
  Pending = "Pending",
  Canceled = "Canceled",
  Rejected = "Rejected",
  RequestReceive = "Request Receive",
  AwaitingConfirmation = "Awaiting Confirmation",
  NeedResponse = "Need Response",
  Finished = "Finished",
  FinishedRevised = "Finished - Revised",
  SendBack = "Send Back",
  RequestRevise = "Request Revise",
  FinishedCanceled = "Finished - Canceled"
}

export namespace RequestStatus {
  export function toId(status: RequestStatus): string {
    switch (status) {
      case RequestStatus.Draft:
        return "RS230000001";
      case RequestStatus.Pending:
        return "RS230000002";
      case RequestStatus.Canceled:
        return "RS230000003";
      case RequestStatus.Rejected:
        return "RS230000004";
      case RequestStatus.RequestReceive:
        return "RS230000005";
      case RequestStatus.AwaitingConfirmation:
        return "RS230000006";
      case RequestStatus.NeedResponse:
        return "RS230000007";
      case RequestStatus.Finished:
        return "RS230000008";
      case RequestStatus.FinishedRevised:
        return "RS230000009";
      case RequestStatus.SendBack:
        return "RS230000010";
      case RequestStatus.RequestRevise:
        return "RS230000011"; 
      case RequestStatus.FinishedCanceled:
        return "RS230000012";
      default:
        return "";
    }
  }
}
